import { render, staticRenderFns } from "./RoundStamp.vue?vue&type=template&id=21d4b189&"
import script from "./RoundStamp.vue?vue&type=script&lang=js&"
export * from "./RoundStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports